import React from 'react';
import { Link } from 'react-router-dom';
import { useDarkMode } from '../contexts/DarkModeContext';
import { Product } from '../data/interfaces/Product';
import FeaturedReleaseInfo from './FeaturedReleaseInfo';

interface FeaturedCardProps {
    product: Product;
}

const FeaturedRelease: React.FC<FeaturedCardProps> = ({ product }) => {

    const { isDarkMode } = useDarkMode();

    return (
        <Link to={`/works/${product.slug}`} className="card-link" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className={`release-header card mb-3 ${isDarkMode ? 'dark-mode-2' : 'light-mode-2'}`}>
                <div className="row g-0">
                    {/* Left column: Main preview */}
                    <div className="col-lg-7 main-preview">
                        <img
                            src={product.thumbnailUrl}
                            className="img-fluid rounded"
                            alt={product.title}
                        />
                    </div>

                    {/* Right column: Information */}
                    <div className="col-lg-5">
                        <FeaturedReleaseInfo
                            product={product}
                        />
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default FeaturedRelease;
